export default [
    {
        name: 'lists.all',
        path: '/lists',
        component: () => import("@/views/modules/lists/pages/List.vue")
    }
]
